import {
  Directive, Optional, Host, ElementRef, OnInit, Input
} from '@angular/core';

import { FlickityDirective } from '../flickity/flickity.directive';


export class FlickityChildDirective implements OnInit {

   flickityChild: any;

  constructor(private el: ElementRef,
                private parent?: FlickityDirective) {}

  ngOnInit(): void {
    if (!this.parent) {
      return;
    }

    this.parent.append(this.el.nativeElement);
  }
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{ selector: '[flickityChild]' }, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ElementRef, },
{type: FlickityDirective, decorators: [{ type: Optional }, { type: Host }, ]},
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'flickityChild': [{ type: Input },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
